// Libs
import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimesCircle } from "@fortawesome/free-solid-svg-icons";

const MealsForDate = ({mealsOnDay, today, formattedDate, cancelMeal}) => {
    return (
        <>
            {mealsOnDay.map((meal) => {
                let bgColor = +meal.type === 0 ? "rgb(58, 135, 173)" : "rgb(63, 165, 216)"; // Check for meal type (once-off Vs. recurring)
                bgColor = meal.allergic ? "rgb(153, 50, 204)" : bgColor; // Check for allergies
                bgColor = meal.suspended || +meal.cancelled === 1 || +meal.approved === 0 ? "rgb(209, 91, 71)" : bgColor; // Check for meal validity
                let btnClass = meal.suspended || +meal.cancelled === 1 ? "btn-outline-light" : "btn-danger";
                let meal_temperature = meal.temperature !== "" ? "(" + meal.temperature + ")" : "";
                return (
                    <tr key={meal.entry_id} className="border-bottom">
                        <td className="border-0 rounded-left" style={{ width: 30, backgroundColor: bgColor }}>{meal.qty}x</td>
                        <td className="border-0" style={{ backgroundColor: bgColor }}>{meal.meal.name} {meal_temperature}</td>
                        <td className="border-0 rounded-right" style={{ width: 30, backgroundColor: bgColor }}>
                            <button
                                className={"btn btn-sm btn-block " + btnClass}
                                disabled={today.isAfter(formattedDate)}
                                onClick={() => cancelMeal(meal)}
                            >
                                <FontAwesomeIcon icon={faTimesCircle} />
                            </button>
                        </td>
                    </tr>
                );
            })}
        </>
    )
}

export default MealsForDate;